import { getDisputesCount, getFiles, getFilesAxios } from "@/api/file";
import { parseImages } from '@/scripts/filesImages.js';
import { findFilterGroupByName, sortFilesByAssetType } from '@/scripts/sortFilesByAssetType.mjs';
import constants from '@/constants/index.js';

export default {
    state: {
        images: [],
        imageCount: 0,
        imageReleased: 0,
        selectedIds: [],
        // Rows the bulk bar's game/model selects point at, and rows a bulk
        // action is working on right now: the row paints itself by these.
        busyIds: [],
        // Open disputes across the catalogue, for the sidebar badge. Polled
        // with the corporate-requests count, and set from the disputes page's
        // own total on every refetch, so a verdict moves it at once.
        disputesCount: 0,

        isShowBigPreview: false,
        selectFile: null,
    },
    getters: {
        IMAGES: state => {return state.images},
        IMAGE_COUNT: state => {return state.imageCount},
        SELECTED_IDS: state => state.selectedIds,
        BUSY_IDS: state => state.busyIds,
        DISPUTES_COUNT: state => state.disputesCount,
        IMAGE_RELEASED: state => {return state.imageReleased},
        
        IS_SHOW_BIG_PREVIEW: state => {return state.isShowBigPreview},
        SELECT_FILE: state => {return state.selectFile},

        CHECK_EDIT_FILE: state => {
            for (let index = 0; index < state.images.length; index++) {
                if (state.images[index].isEdit === true) {
                    return true;
                }
            }
            return false;
        }
    },
    mutations: {
        IMAGES: (state, payload) => { state.images = payload },
        IMAGE_COUNT: (state, payload) => { state.imageCount = payload },
        // Checkboxes on the disputes list. Kept in the store so the bar above
        // the list and the rows agree without prop-drilling.
        TOGGLE_SELECTED: (state, id) => {
            const i = state.selectedIds.indexOf(id);
            if (i >= 0) state.selectedIds.splice(i, 1);
            else state.selectedIds.push(id);
        },
        SET_SELECTED: (state, ids) => { state.selectedIds = [...new Set(ids)] },
        CLEAR_SELECTED: (state) => { state.selectedIds = [] },
        SET_BUSY: (state, ids) => { state.busyIds = ids },
        IMAGE_RELEASED: (state, payload) => { state.imageReleased = payload },
        DISPUTES_COUNT: (state, payload) => { state.disputesCount = payload },
        IMAGE_DELETE_BY_ID: (state, id) => {
            const searchImageIndex = state.images.map(image => image.id).indexOf(id);
            if (searchImageIndex >= 0) {
                state.images.splice(searchImageIndex, 1);
                state.imageCount -= 1;
            }
            const si = state.selectedIds.indexOf(id);
            if (si >= 0) state.selectedIds.splice(si, 1);
        },

        IS_SHOW_BIG_PREVIEW: (state, payload) => {state.isShowBigPreview = payload},
        SELECT_FILE: (state, payload) => {state.selectFile = payload},
    },
    actions: {
        // Both sidebar badges on the one refresh timer.
        loadSidebarCounts: async function(context) {
            await Promise.all([
                context.dispatch('loadPendingCount'),
                context.dispatch('loadDisputesCount'),
            ]);
        },
        loadDisputesCount: async function(context) {
            const count = await getDisputesCount();
            if (count != null) context.commit('DISPUTES_COUNT', count);
        },
        UPDATE_FILES: async function(context) {
            const files = await getFiles();

            if (files[context.getters.ASSET_TYPE_IMAGES] != null) {
                await context.dispatch('UPDATE_IMAGES', files[context.getters.ASSET_TYPE_IMAGES]);
            }
        },
        UPDATE_IMAGES: async function (context, imageFile) {
            if (imageFile.files.length > 0) {
                const imageFilter = await context.getters.FILTER_BY_ASSET_TYPE(
                    context.getters.ASSET_TYPE_IMAGES
                );
                const parsedFiles = await parseImages(imageFile.files, imageFilter);

                // Order the list by the "Asset type" filter value so assets of the same
                // type sit together. Done here rather than in ImageList so that client
                // pagination, ButtonSaveAll/ReleaseAll and MultiEdit — all of which read
                // the IMAGES getter — see one consistent order.
                const assetTypeFilter = findFilterGroupByName(
                    imageFilter,
                    constants.ASSET_TYPE_FILTER_NAME
                );
                const sortedFiles = sortFilesByAssetType(parsedFiles, assetTypeFilter);
                console.debug('[sort] IMAGES sorted by asset type', {
                    count: sortedFiles.length,
                    assetTypeFilterId: assetTypeFilter == null ? null : assetTypeFilter.id,
                });

                context.commit('IMAGES', sortedFiles);
                context.commit('CLEAR_SELECTED');
                context.commit('IMAGE_COUNT', imageFile.total_count);
                // The disputes page just fetched the whole match; the badge is that number.
                if (context.rootGetters.CURRENT_DISPUTED === true && imageFile.total_count != null) {
                    context.commit('DISPUTES_COUNT', imageFile.total_count);
                }
                context.commit('IMAGE_RELEASED', imageFile.released_count);
            }
            else {
                context.commit('IMAGES', []);
                // A server page past the end is empty while the match is not;
                // keep the real count so the pager can step back.
                context.commit('IMAGE_COUNT', imageFile.total_count || 0);
                context.commit('IMAGE_RELEASED', 0);
            }
        }
    }
}